<template>
  <div>
    <router-link class="item" tag="div" :to="(item.type === '微课'?'/play/'+item.id+'/'+item.video_ids:'/systematic/'+item.id)">
      <div class="col col-1">
        <img v-lazy="item.icon">
      </div>
      <div class="col col-2">
        <h4><span v-html="item.title"></span></h4>
        <div class="time">
          <span v-if="item.type==='体系课'">{{item.section}}节 共{{item.duration | format}}</span>
          <span v-if="item.type==='微课'">{{item.duration | format}}</span>
        </div>
        <h5><span v-html="item.user_name"></span>主讲</h5>
        <div class="position">
          <p v-html="item.user_honor"></p>
        </div>
        <div class="price">
          <div class="left">
            <span><i class="iconfont icon-weibiaoti4"></i>{{item.browses}}</span>
            <span><i class="iconfont icon-dianzan"></i>{{item.goods}}</span>
          </div>
          <div class="right">¥ {{item.price}}</div>
        </div>
      </div>
    </router-link>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    item: {
      type: Object,
      default: null
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .item{
    margin-bottom size(40)
    display flex
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    width 100%
    .col{
      display block
    }
    .col-1{
      width 34.7%
      height size(280)
      position relative
      -webkit-border-radius: size(10)
      -moz-border-radius: size(10)
      border-radius: size(10)
      overflow hidden
      img{
        width 100%
        height 100%
      }
      .date{
        position absolute
        bottom: 0
        left: 0
        width: 100%
        height: size(36)
        line-height size(36)
        text-align center
        color #fff
        font-size size(22)
        background-color: rgba(0, 0, 0, .5)
      }
    }
    .col-2{
      width 65.3%
      padding-left size(26)
      padding-top size(12)
      padding-bottom size(20)
      display: -webkit-box
      display: -webkit-flex
      display: -ms-flexbox
      display: flex
      -webkit-box-orient: vertical
      -webkit-box-direction: normal
      -webkit-flex-direction: column
      -ms-flex-direction: column
      flex-direction: column
      -webkit-box-pack: justify
      -webkit-justify-content: space-between
      -ms-flex-pack: justify
      justify-content: space-between
      h4{
        font-size size(32)
        width: 100%
        font-weight 900
        overflow hidden
        text-overflow ellipsis
        //white-space nowrap
        display: -webkit-box
        -webkit-line-clamp: 2
        -webkit-box-orient: vertical
        line-height 1.4
      }
      .time{
        font-size size(24)
        color $color-text-l
        line-height 1.6//
      }
      h5{
        font-size size(28)
        line-height 2//
        span{
          display inline-block
          margin-right: 5px
        }
      }
      .position{
        height size(72 / 2)
        p{
          font-size size(26)
          line-height 1.4
          color $color-text-l
          // display: -webkit-box
          // -webkit-line-clamp: 2
          // -webkit-box-orient: vertical
          white-space nowrap
          text-overflow ellipsis
          overflow: hidden

        }
      }

      .price{
        display table
        width 100%
        color: $color-text-l
        line-height 1.6//
        >div{
          display table-cell
          vertical-align middle
          width 50%
        }
        .left{
          font-size: size(20)
          span{
            display inline-block
            i{
              font-size size(28)
              margin-right: 2px
            }
            i.icon-weibiaoti4{
              position relative
              top size(3)
            }
          }
        }
        .right{
          text-align right
          font-size size(28)
          color $color-theme
          font-weight 900
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/jingpin/card-jpkc.vue